module.exports = __webpack_public_path__ + "img/speed3.436956cf.png";